import {
  RadioSelectionRenderer,
  type RadioSelectionRendererProps,
  getRendererProps,
} from '@exam-center/components';
import { Flex, SectionTitle, Text } from '@shared/components';

export interface ProctorTypeFieldProps {
  fields: {
    proctorType: RadioSelectionRendererProps;
  };
}

export default function ProctorTypeField(props: Readonly<ProctorTypeFieldProps>) {
  const {
    fields: { proctorType },
  } = props;

  const isViewMode = proctorType.mode === 'view';

  return (
    <Flex sx={(theme) => ({ flexDirection: 'column', gap: theme.spacing(6) })}>
      <SectionTitle title='Proctor Type' />
      <Flex sx={(theme) => ({ alignItems: 'center', gap: theme.spacing(6) })}>
        <Text sx={{ flexBasis: '240px' }} variant='body1Semibold'>
          ประเภทผู้คุมสอบ
        </Text>
        {isViewMode ? (
          proctorType.value
        ) : (
          <RadioSelectionRenderer
            {...getRendererProps(proctorType, {
              required: true,
              row: true,
              options:
                proctorType.slotProps && 'options' in proctorType.slotProps
                  ? proctorType.slotProps.options
                  : [],
            })}
          />
        )}
      </Flex>
    </Flex>
  );
}
